import React from 'react';
import { IconButton } from 'components/IconButton';
import TextField, {
    TextFieldProps,
} from 'components/interface/textField/TextField';

export default function PasswordField({
    endAdornmentSx = [],
    ...props
}: TextFieldProps) {
    const [show, setShow] = React.useState(false);

    return (
        <TextField
            {...props}
            type={show ? 'text' : 'password'}
            endAdornmentSx={[
                { color: 'text.primary' },
                ...(Array.isArray(endAdornmentSx)
                    ? endAdornmentSx
                    : [endAdornmentSx]),
            ]}
            endAdornment={
                <IconButton
                    icon={show ? 'visibility_off' : 'visibility'}
                    variant='text'
                    size='xs'
                    sx={{ color: 'inherit' }}
                    onClick={event => {
                        event.stopPropagation();
                        setShow(prev => !prev);
                    }}
                />
            }
        />
    );
}
